<template>
  <div class="personalSetting">
    <div class="userInfo">
      <div class="left">
        <img src="@/assets/images/user/userPhone.png"/>
        <span>会员手机</span>
      </div>
      <span class="right">{{Telephone}}</span>
    </div>
    <div class="aboutBox">
      <p class="title">身份信息</p>
      <div class="item">
        <span>姓名</span>
        <input placeholder="请填写姓名" v-if="!hasName" class="grayInputBox" v-model="Name" maxlength="12"/>
        <span class="grayBox" v-else>{{Name}}</span>
      </div>
      <div class="item">
        <span>身份证</span>
        <input placeholder="请填写本人身份证" v-if="!hasIdCardNo" v-model="IdCardNo" class="grayInputBox" maxlength="18"/>
        <span class="grayBox" v-else>{{IdCardNo}}</span>
      </div>
    </div>
<!--    <div class="aboutBox">-->
<!--      <p class="title">银行卡信息<span class="tip">（持卡人需与身份证一致）</span></p>-->
<!--      <div class="item">-->
<!--        <span>归属银行</span>-->
<!--        <div class="selectedBank" @click="showBankCardBox">-->
<!--          <span>{{Bank || "请选择"}}</span>-->
<!--          <img src="@/assets/images/user/rightArrow.png" class="arrowIcon"/>-->
<!--        </div>-->
<!--      </div>-->
<!--      <div class="item">-->
<!--        <span>银行卡号</span>-->
<!--        <input type="text" placeholder="请输入银行卡卡号" class="grayInputBox" maxlength="19" v-model="BankCardNo"/>-->
<!--      </div>-->
<!--    </div>-->
<!--    <div class="withdrawBtn" @click="saveSetting">保存</div>-->

    <div class="bankCardContainer" v-show="showBankCard">
      <div class="mask" @click="showBankCard = false"></div>
      <div class="box">
        <div class="top">
          <span></span>
          <span>选择银行卡</span>
          <img/>
        </div>
        <div class="noData" v-if="bankList.length == 0">暂无银行卡数据</div>
        <scroll class="content" :data="bankList" v-if="bankList.length > 0">
          <ul>
            <li v-for="item in bankList" :key="item.ID" @click="selectBank(item)">
              <div class="left">
                <span class="name">{{item.Name}}</span>
              </div>
              <img src="@/assets/images/user/selected.png" class="rightIcon" v-if="currentBankId == item.ID"/>
              <img src="@/assets/images/user/unSelected.png" class="rightIcon" v-else/>
            </li>
            <li class="noMore">没有啦~</li>
          </ul>
        </scroll>
      </div>
    </div>
  </div>
</template>
<script>
import scroll from "@/components/scroll.vue";
import { getBanks, getBankCard, saveBankCard } from "@/utils/api";
export default {
  name: "personalSetting",
  data() {
    return {
      hasName:false,
      hasIdCardNo:false,
      showBankCard: false,
      Telephone: "",
      Name: "",
      IdCardNo: "",
      Bank: "",
      BankCardNo: "",
      currentBankId: -1,
      bankList: [],
    };
  },
  components: {
    scroll
  },
  created() {},
  mounted() {
    this.initData();
  },
  methods: {
    async initData() {

      await this.getUserInfo();
    },
    async getUserInfo() {
      let userInfo = JSON.parse(localStorage.getItem("userInfo")); //登录信息
      userInfo.Name?this.hasName = true:this.hasName = false;
      userInfo.IDCardNo?this.hasIdCardNo = true:this.hasIdCardNo = false;
      this.Name = userInfo.Name;
      this.Telephone = userInfo.Telephone;
      this.IdCardNo = userInfo.IDCardNo;
      let res = await getBankCard();
      if (res.Code == 100) {
        this.BankCardNo = res.Data.BankCardNo;
        this.Bank = res.Data.Bank;
      }
    },
    async getBankList() {
      let res = await getBanks();
      if (res.Code == 100 && res.Data.length > 0) {
        this.bankList = res.Data;
        this.bankList.forEach((item, index) => {
        if (item.Name == this.Bank) {
          this.currentBankId = item.ID;
        }
      });
      }
    },
    showBankCardBox(){
      this.showBankCard = true;
      this.getBankList();
    },
    selectBank(bankObj) {
      if(bankObj.Name == this.Bank){
        this.showBankCard = false;
      }else{
        this.currentBankId = bankObj.ID;
        this.Bank = bankObj.Name;
        this.BankCardNo = "";
        this.showBankCard = false;
      }
    },
    async saveSetting() {
     if (!this.Name) {
       this.flexible.showToast({
         content: '姓名不能为空！',
         duration: 2000
       });
       return false;
     }
     if (!this.IdCardNo || this.IdCardNo.length != 18) {
       this.flexible.showToast({
         content: '请输入正确的身份证号！',
         duration: 2000
       });
       return
     }
     if (!this.Bank) {
       this.flexible.showToast({
         content: '请选择银行！',
         duration: 2000
       });
       return
     }
     if (!this.BankCardNo || (this.BankCardNo.length != 16 && this.BankCardNo.length != 19) ) {
       this.flexible.showToast({
         content: '请输入正确的银行卡号！',
         duration: 2000
       });
       return
     }
      let data = {
        IdCardNo: this.IdCardNo,
        BankCardNo: this.BankCardNo,
        Bank: this.Bank,
        Name: this.Name
      };
      let res = await saveBankCard({
        data: data,
        isLoading: true,
        loadContent: "保存中..."
      });
      if (res.Code == 100) {
        this.flexible.showToast({
          type: "success",
          content: "保存成功",
          success: () => {
            this.$router.replace({path: this.prevPath || "/userCenter"})
          }
        });
      }
    },
  }
};
</script>
<style lang="scss" scoped type="text/scss">
.personalSetting {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 110px 35px 0;
  box-sizing: border-box;
  background: #fff;
  .userInfo {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 35px 20px;
    .left {
      display: flex;
      align-items: center;
      font-size: 28px;
      img {
        width: 48px;
        height: 48px;
        margin-right: 15px;
      }
    }
    .right {
      color: #9f9f9f;
      font-size: 26px;
    }
  }
  .aboutBox {
    padding: 30px 0;
    border-radius: 6px;
    box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.16);
    -webkit-box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.16);
    margin-bottom: 26px;
    .title {
      font-size: 36px;
      color: #000000;
      font-weight: bold;
      border-left: 10px solid #027FFF;
      padding-left: 22px;
      .tip {
        font-size: 24px;
        color: #9f9f9f;
      }
    }
    .item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 50px 30px 0;
      font-size: 26px;
      .bolderInput {
        font-weight: bold;
      }
      .grayInputBox {
        background: #ebebeb;
        width: 360px;
        height: 70px;
        padding-right: 32px;
        box-sizing: border-box;
        color: #000;
        text-align: right;
      }
      .grayBox {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        background: #ebebeb;
        width: 360px;
        height: 70px;
        padding-right: 32px;
        box-sizing: border-box;
        color: #000;
        img {
          width: 24px;
          height: 24px;
          margin-left: 5px;
        }
      }
      .selectedBank {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        width: 350px;
        height: 70px;
        padding-right: 10px;
        background: #ebebeb;
        .arrowIcon {
          width: 32px;
          height: 32px;
        }
        span {
          color: #000;
          font-size: 26px;
          margin: 0 12px;
        }
      }
    }
    .item:last-child {
      padding-bottom: 28px;
    }
    .mainBox {
      padding: 0 30px;
      .withdrawBox {
        display: flex;
        justify-content: space-between;
        align-items: flex-end;
        padding: 20px 0;
        border-bottom: 1px solid #dcdcdc;/*no*/
        .left {
          display: flex;
          align-items: flex-end;
          span {
            font-size: 34px;
            margin-bottom: 7px;
            margin-right: 10px;
          }
          input {
            width: 400px;
            font-size: 46px;
            font-weight: bold;
          }
        }
        .right {
          font-size: 26px;
          color: #027FFF;
        }
      }
      p {
        margin-top: 20px;
        color: #9f9f9f;
        padding-bottom: 20px;
      }
    }
  }
  .withdrawBtn {
    width: 100%;
    height: 90px;
    text-align: center;
    line-height: 90px;
    background: #027FFF;
    color: #fff;
    font-size: 28px;
    margin-top: 15px;
  }
  .bankCardContainer {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: 100000;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    height: 100%;
    width: 100%;
    .mask {
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
      height: 100%;
      background-color: #000;
      opacity: 0.7;
    }
    .box {
      position: relative;
      z-index: 1000;
      display: flex;
      flex-direction: column;
      width: 100%;
      height: 900px;
      background: #fff;
      .top {
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 88px;
        border-bottom: 1px solid #dcdcdc; /*no*/
        span {
          font-size: 32px;
        }
      }
      .noData{
        display: flex;
        align-items: center;
        justify-content: center;
        padding:50px 0;
      }
      .content {
        flex: 1;
        overflow: hidden;
        padding: 0 45px;
        ul {
          li {
            display: flex;
            align-items: center;
            justify-content: space-between;
            height: 115px;
            border-bottom: 1px solid #dcdcdc;/*no*/
            .left {
              display: flex;
              align-items: center;
              img {
                width: 40px;
                height: 40px;
              }
              span {
                font-size: 26px;
                color: #9f9f9f;
              }
              span.name {
                color: #000;
                margin: 0 14px;
              }
            }
            .rightIcon {
              width: 32px;
              height: 32px;
            }
          }
          li.noMore{
            display: flex;
            align-items: center;
            justify-content: center;
          }
          li:last-child{
            border-bottom:none;
          }
        }
        .addBankCard {
          display: flex;
          align-items: center;
          justify-content: space-between;
          height: 115px;
          border-bottom: 1px solid #dcdcdc;/*no*/
          .left {
            display: flex;
            align-items: center;
            img {
              width: 48px;
              height: 48px;
            }
            span {
              font-size: 26px;
              color: #000000;
            }
          }
          .leftArrow {
            width: 32px;
            height: 32px;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/user/personalSetting.vue